const chainConfig = {
  algorithms: ["HS256"],
  tokenSecret: process.env.TOKEN_SECRET || "testtesttesttesttesttesttesttesttesttesttesttesttesttesttesttesttesttesttesttesttesttest"
};
const shortenHash = (hash = "", charLength = 6, postCharLength) => {
  if (postCharLength) {
    return hash.slice(0, charLength) + "..." + hash.slice(hash.length - postCharLength, hash.length);
  }
  return hash.slice(0, charLength);
};
function resolveUsernamePublicAddress({
  publicAddress
}) {
  return shortenHash(publicAddress, 5, 4);
}

export { chainConfig, resolveUsernamePublicAddress, shortenHash };
